import { TRootState } from "@/store";
import { createSelector } from "reselect";

export const selectDashboard = (state: TRootState) => state.dashboard;

export const selectDashboardKPI = createSelector(
  [selectDashboard],
  (dashboard) => dashboard.kpi_amount
);

export const selectLineGraphResiliation = createSelector(
  [selectDashboard],
  (dashboard) => dashboard.lineGraphResiliation
);

export const selectLineGraphAbonnement = createSelector(
  [selectDashboard],
  (dashboard) => dashboard.lineGraphAbonnement
);

export const selectTableauSecteur = createSelector(
  [selectDashboard],
  (dashboard) => dashboard.tableauSecteur
);

export const selectTableauGlobal = createSelector(
  [selectDashboard],
  (dashboard) => dashboard.tableauGlobal
);
export const selectTableauGlobalResilie = createSelector(
  [selectDashboard],
  (dashboard) => dashboard.tableauGlobalResilie
);

export const selectIsLoadingDashboard = createSelector(
  [selectDashboard],
  (dashboard) => dashboard.isLoadingDashboard
);

export const selectIsLoadingLineChartAbonnement = createSelector(
  [selectDashboard],
  (dashboard) => dashboard.isLoadingLineChartAbonnement
);

export const selectIsLoadingLineChartResiliation = createSelector(
  [selectDashboard],
  (dashboard) => dashboard.isLoadingLineChartResiliation
);
